import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('vxc-modal')
export class TModal extends LitElement {
    static styles = css`
    .modal-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1050;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.15s linear;
    }

    .modal-backdrop.show {
      opacity: 1;
      visibility: visible;
    }

    .modal {
      background: white;
      border-radius: 0.3rem;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      width: 90%;
      transform: translateY(-50px);
      transition: transform 0.3s ease-out;
    }

    /* Modal sizes */
    .modal.size-sm {
      max-width: 300px;
    }

    .modal.size-default {
      max-width: 500px;
    }

    .modal.size-lg {
      max-width: 800px;
    }

    .modal.size-xl {
      max-width: 1140px;
    }

    /* Fullscreen styles */
    .modal.fullscreen {
      max-width: 100%;
      width: 100%;
      height: 100vh;
      margin: 0;
      border-radius: 0;
    }

    .modal.fullscreen .modal-header {
      border-radius: 0;
    }

    .modal.fullscreen .modal-body {
      flex: 1;
      overflow-y: auto;
    }

    .show .modal {
      transform: translateY(0);
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem;
      border-bottom: 1px solid #dee2e6;
    }

    .modal-title {
      margin: 0;
      font-size: 1.25rem;
    }

    .close-button {
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
      padding: 0.5rem;
      margin: -0.5rem;
      color: #6c757d;
    }

    .modal-body {
      padding: 1rem;
    }

    .modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      padding: 1rem;
      border-top: 1px solid #dee2e6;
    }
  `;

    @property({ type: Boolean, reflect: true })
    open = false;

    @property({ type: String })
    title = '';

    @property({ type: String })
    size: 'sm' | 'default' | 'lg' | 'xl' = 'default';

    @property({ type: Boolean })
    fullscreen = false;

    private close() {
        this.open = false;
        this.dispatchEvent(new CustomEvent('modal-close'));
    }

    private handleBackdropClick(e: MouseEvent) {
        if (e.target === e.currentTarget) {
            this.close();
        }
    }

    show() {
        console.log('modal show')
        this.open = true
    }

    hide() {
        console.log('modal hide')
        this.open = false
    }

    render() {
        return html`
            <div
                class="modal-backdrop ${this.open ? 'show' : ''}"
                @click=${this.handleBackdropClick}
            >
            <div class="modal size-${this.size} ${this.fullscreen ? 'fullscreen' : ''}">
                <div class="modal-header">
                    <h5 class="modal-title">
                        ${this.title}
                    </h5>
                    <button
                        type="button"
                        class="close-button"
                        @click=${this.close}
                        aria-label="Close"
                    >
                    ×
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    `;
  }
}

/** 
 * to declare the type TModal 
 * so that when I call 
 * var element = document.querySelector('vx-modal')
 * element has the type TModal
 **/
declare global {
  interface HTMLElementTagNameMap {
    'vxc-modal': TModal;
  }
}